export const EMPTY_OBJ = {}

export function buildLegendConfig (displayLegend = EMPTY_OBJ) {
  if (!displayLegend.show) return undefined
  const isVertical = displayLegend.position === 'left' || displayLegend.position === 'right'
  return {
    show: true,
    ...(isVertical
      ? { orient: 'vertical', [displayLegend.position]: '0%', top: 'center' }
      : { orient: 'horizontal', [displayLegend.position || 'bottom']: '0%', left: 'center' })
  }
}

export function buildLabelConfig (displayLabel = EMPTY_OBJ) {
  return {
    show: displayLabel.show !== false,
    ...(displayLabel.position && { position: displayLabel.position }),
    ...(displayLabel.rotate && { rotate: displayLabel.rotate }),
    ...(displayLabel.fontSize && { fontSize: displayLabel.fontSize })
  }
}
